











import { Vue, Component } from 'vue-property-decorator';
import { mdbContainer } from '@folky-tools/mdbvue';

@Component({ components: { mdbContainer } })
export default class PrivacyPolicyView extends Vue {
    private navbarClasses: string = '';

    private mounted(): void {
        this.$root.$emit('changeNavbarClasses', this.navbarClasses);
        this.$root.$emit('change-active-page', 'views.info.privacyPolicyView.title');
    }
}
